import React, { Component } from "react";
import PropTypes from "prop-types";
import { Icon, edit, trash, more } from "Icons/index";
import t from "Utils/translation";
import DropdownMenu from "react-dd-menu";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";

import cx from "classnames";
import s from "./mainCustomizationRow.scss";

const ContextTypes = {
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

export default class MainCustomizationRow extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);

    this.state = {
      ddOpened: false,
    };
  }

  toggle() {
    this.setState({ ddOpened: !this.state.ddOpened });
  }

  close() {
    this.setState({ ddOpened: false });
  }

  render() {
    const {
      mainCustomization,
      showMainCustomization,
      showDeleteConfirmModal,
      showManager,
      showActions = true,
      canEdit = true,
    } = this.props;
    const { isMobileDevice, isMediaMobile, isMediaSM, isMediaMD, isMediaLG } = this.context;

    let image;
    if (mainCustomization.logo) {
      image = (
        <div className={s.logo}>
          <img src={`${BASE_URL_PUBLIC_ASSETS}${mainCustomization.logo}`} alt="logo" title="logo" />
        </div>
      );
    } else {
      image = (
        <div className={s.logo}>
          <img src={`${BASE_URL_PUBLIC_ASSETS}/logo_panel.svg`} alt="logo" title="logo" />
        </div>
      );
    }

    return (
      <tr key={mainCustomization.id}>
        <td data-label={t("table.header.logo")}>{image}</td>
        {showManager && (
          <td data-label={t("table.header.managers")} className="textOverflow">
            {mainCustomization.manager_fullname} [{mainCustomization.manager_code}]
          </td>
        )}
        <td data-label={t("table.header.company")} className="textOverflow">
          {mainCustomization.company}
        </td>
        <td data-label={t("table.header.supportURL")} className="hideOnMobile">
          {mainCustomization.help_desk_url}
        </td>
        {showActions && (
          <td>
            <DropdownMenu
              animate={false}
              isOpen={this.state.ddOpened}
              close={this.close}
              toggle={<ButtonIcon icon={more} onClick={this.toggle} />}
              align="right"
            >
              {canEdit && (
                <li>
                  <a onClick={showMainCustomization}>
                    <Icon svg={edit} />
                    <div>{t("button.edit")}</div>
                  </a>
                </li>
              )}

              <li>
                <a onClick={() => showDeleteConfirmModal(mainCustomization)}>
                  <Icon svg={trash} />
                  <div>{t("ddMenu.delete")}</div>
                </a>
              </li>

              {isMediaMobile() && (
                <li className="cancelBtn">
                  <a>
                    <div>{t("ddMenu.cancel")}</div>
                  </a>
                </li>
              )}
            </DropdownMenu>
          </td>
        )}
      </tr>
    );
  }
}

MainCustomizationRow.contextTypes = ContextTypes;
